import { useGlobalQuery } from '@/state/query-client/hooks';
import { createApplicationHooks } from '@/modules/service-desk/shared/application-hooks';
import {
  deleteNocApplication,
  generateNocLetter,
  getNocTypes,
  nocApi,
  reviewNocApplication,
  submitNocApplication,
} from '../services/noc.service';
import { NocApplication } from '../types/noc.types';

const hooks = createApplicationHooks<NocApplication>({
  key: 'noc',
  api: nocApi,
  withdrawWorkflow: 'NOC_APPLICATION_WITHDRAW',
});

export const useNocApplications = hooks.useApplications;
export const useNocApplication = hooks.useApplication;
export const useWithdrawNoc = hooks.useWithdrawApplication;

export const useSubmitNoc = () =>
  hooks.useApplicationMutation(submitNocApplication, 'REQUEST_SUBMITTED');
export const useReviewNoc = () =>
  hooks.useApplicationMutation(reviewNocApplication, 'REQUEST_UPDATED');
export const useGenerateNoc = () =>
  hooks.useApplicationMutation(generateNocLetter, 'NOC_GENERATED');
export const useDeleteNoc = () =>
  hooks.useApplicationMutation(deleteNocApplication, 'REQUEST_DELETED');

export const useNocTypes = () =>
  useGlobalQuery({
    queryKey: ['hr-service-desk', 'noc', 'types'],
    queryFn: getNocTypes,
    staleTime: 30 * 60 * 1000,
  });
